module.exports = __webpack_public_path__ + "img/소나기.20b9d679.png";